import request from '@/utils/request'

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/aromatics/industry/noAuth/boardList',
        method: 'get',
        params: query
    })
}

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/aromatics/industry/adipicAcidNewsList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/aromatics/industry/getAdipicAcidNewsInfo/${id}`,
        method: 'get',
    })
}

// 企业动态列表
export function dynamicList(query) {
    return request({
        url: '/aromatics/industry/adipicAcidCompanyNewsList',
        method: 'get',
        params: query
    })
}

// 企业动态详情
export function dynamicDetail(id) {
    return request({
        url: `/aromatics/industry/getAdipicAcidCompanyNewsInfo/${id}`,
        method: 'get',
    })
}

// 下游动态列表
export function downstreamList(query) {
    return request({
        url: '/aromatics/industry/adipicAcidDownstreamList',
        method: 'get',
        params: query
    })
}

// 下游动态详情
export function downstreamDetail(id) {
    return request({
        url: `/aromatics/industry/getAdipicAcidDownstreamInfo/${id}`,
        method: 'get',
    })
}

// 产量列表
export function yieldList(query) {
    return request({
        url: '/aromatics/druidEnter/adipicAcidYieldList',
        method: 'get',
        params: query
    })
}

// 产量详情
export function yieldDetail(query) {
    return request({
        url: `/aromatics/druidEnter/getAdipicAcidYieldInfo`,
        method: 'get',
        params:query
    })
}

// 库存列表
export function stockList(query) {
    return request({
        url: '/aromatics/druidEnter/adipicAcidStockList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(query) {
    return request({
        url: `/aromatics/druidEnter/getAdipicAcidStockInfo`,
        method: 'get',
        params:query
    })
}

// 前两个价格列表（无权限）
export function priceNoAuthList(query) {
    return request({
        url: '/aromatics/metatron/price/noAuth/petroleumPlaceList',
        method: 'get',
        params: query
    })
}

// 前价格列表
export function priceList(query) {
    return request({
        url: '/aromatics/metatron/price/adipicAcidPriceList',
        method: 'get',
        params: query
    })
}

// 前价格详情
export function priceDetail(query) {
    return request({
        url: `/aromatics/metatron/price/detailsAdipicAcidInfo`,
        method: 'get',
        params:query
    })
}

// 后价格列表
export function backPriceList(query) {
    return request({
        url: '/aromatics/industry/adipicAcidPriceList',
        method: 'get',
        params: query
    })
}

// 后价格详情
export function backPriceDetail(id) {
    return request({
        url: `/aromatics/industry/getAdipicAcidPriceInfo/${id}`,
        method: 'get',
    })
}

// 研究报告列表(首页无权限)
export function reportNoAuthList(query) {
    return request({
        url: '/aromatics/report/noAuth/list',
        method: 'get',
        params: query
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/aromatics/report/reportAdipicAcidList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function reportDetail(id) {
    return request({
        url: `/aromatics/report/boardAdipicAcidInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: '/aromatics/report/technicalAdipicAcidList',
        method: 'get',
        params: query
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/aromatics/report/technicalAdipicAcidInfo/${id}`,
        method: 'get',
    })
}

// 首页列表（无权限）
export function queryPageList(query) {
    return request({
        url: '/aromatics/druidEnter/noAuth/queryPage',
        method: 'get',
        params: query
    })
}

// 产业链
export function chainList(query) {
    return request({
        url: '/aromatics/metatron/chain/noAuth/chainPrice',
        method: 'get',
        params: query
    })
}

// 价格折线图
export function lineData(query) {
    return request({
        url: '/aromatics/metatron/detail/lineChart',
        method: 'get',
        params: query
    })
}

// 三年地图
export function threeLineData(query) {
    return request({
        url: '/aromatics/metatron/detail/lineChart',
        method: 'get',
        params: query
    })
}
